import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-svgo_sort-asc",
  "use": "icon-svgo_sort-asc-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-svgo_sort-asc\"><path fill-opacity=\"0\" d=\"M0 0h17v17H0z\" /><path d=\"M10.911 14V1.747m0 0l3.522 4.012M1 8.96h6.121M1 4.625h6.121M1 13.355h6.121\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol